/**
 * Converts a numeric value assumed to be in `px` to `rem` (returns a string containing the `rem` unit, unless `asNumber` is `true`).
 */

export default (valueInPx, asNumber = false) => (asNumber ? valueInPx / 16 : `${valueInPx / 16}rem`)
